import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/attori/Attori.vue'),
		meta: {
			title: 'people',
			acl: 'section.attori'
		}
	},
	{
		path: 'new',
		component: () => import('@/views/attori/attore/AttoreTabs.vue'),
		meta: {
			title: 'new-person',
			acl: 'section.attori'
		}
	},
	{
		path: ':actorid/edit',
		component: () => import('@/views/attori/attore/AttoreTabs.vue'),
		meta: {
			title: 'edit-person',
			acl: 'section.attori'
		}
	}
];

export default routes;